import React from 'react'
import NavHeader from '../headers/nav-header'
import * as classes from './navigator.module.css'

const Navigator: React.FC = () => {
  try {
    
    return (
      <div className={classes.container} >
        <NavHeader />
      </div>
    )
  } catch (e) {return null}
}

export default Navigator;